import { render } from "./S315045.vue?vue&type=template&id=4cd35edf"
const script = {}
script.render = render

export default script